<div class="modal-content">
  <div class="modal-header align-items-center">
    <span class="modal-title h5 m-auto" jhiTranslate="login.title"></span>
    <i aria-label="Close" (click)="close()" class="close pull-right align-middle fas fa-times"> </i>
  </div>

  <div class="modal-body text-center">
    <jhi-login-form
      [loginType]="loginType"
      [description]="description"
      (redirectEvent)="handleClick({ second: true })"
      (cancelEvent)="handleClick({ cancel: true })"
    ></jhi-login-form>
  </div>
</div>
